import { Component, ElementRef, OnDestroy, afterNextRender, input, viewChild } from '@angular/core';
import { type AnimationItem } from 'lottie-web';

@Component({
  selector: 'app-spinner',
  standalone: true,
  template: `
    <div
      #container
      class="spinner-container"
      [style.width.px]="sizeMap[size()]"
      [style.height.px]="sizeMap[size()]"
    ></div>
  `,
  styles: [
    `
      .spinner-container {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
})
export class SpinnerComponent implements OnDestroy {
  size = input<'sm' | 'md' | 'lg'>('md');

  private readonly container = viewChild.required<ElementRef<HTMLElement>>('container');
  private animation?: AnimationItem;

  protected sizeMap: Record<string, number> = {
    sm: 40,
    md: 72,
    lg: 120,
  };

  constructor() {
    // Lottie touches the DOM and only runs in the browser, so defer to render.
    afterNextRender(() => this.startAnimation());
  }

  /** Boots the lottie animation into the container element (no-op if already running). */
  protected async startAnimation(): Promise<void> {
    if (this.animation) return;
    const { default: lottie } = await import('lottie-web');
    this.animation = lottie.loadAnimation({
      container: this.container().nativeElement,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'assets/animations/loading.json',
    });
  }

  ngOnDestroy(): void {
    this.animation?.destroy();
  }
}
